angular.module('iw.frontyard.signup')
    .service('SignupLendingAPIHelper', function ($http,
                                                 $window,
                                                 SignupReasonsForLoanChoices,
                                                 SignupReasonsForLoanChoicesDE) {

        var LENDING_API_STATE_URL = '/api/lending/v1/state/';
        var API_EMAIL_CHECKER_URL = '/api/lending/v1/email_availability/';

        var httpOptions = {
            headers: {
                'xsrfCookieName': 'csrftoken',
                'xsrfHeaderName': 'X-CSRFToken',
                'Authorization': 'Token iwoca-9e4606290c6294a6b40e15c9bb75cd2daf0'
            }
        };

        class SignupLendingAPIHelper {
            constructor() {
            }

            static getChoices() {
                switch($window.SITE_CODE) {
                    case 'de':
                        return SignupReasonsForLoanChoicesDE;
                    default:
                        return SignupReasonsForLoanChoices;
                }
            }

            static replaceNonNumericCharacters(number) {
                switch($window.SITE_CODE){
                    case 'de':
                        return number.toString().replace(/[^0-9]+/g, '');
                    default:
                        return number.toString().replace(/[^0-9.]+/g, '');
                }
            }

            static formatNumber(value) {
                switch ($window.SITE_CODE) {
                    case 'pl':
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    case 'uk':
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    case 'de':
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    default:
                        return value;
                }
            }

            static getSignupURL() {
                switch ($window.SITE_CODE) {
                    case 'pl':
                    case 'de':
                        return '/konto/';
                    default:
                        return '/account/';
                }
            }

            serializeDataToSend(signupState) {
                var serialised = {
                    application: {
                        people: [{
                            uid: signupState.personUID,
                            first_name: '',
                            last_name: '',
                            roles: ['applicant'],
                            emails: [{
                                email: signupState.email,
                                uid: signupState.emailUID,
                                type: 'primary',
                                marketing_opt_in: {
                                    agreed: signupState.marketingEmails
                                }
                            }],
                        }],
                        requested_products: {
                            credit_facility: {
                                approval: serializeLoanRequest(signupState)
                            }
                        }
                    }
                };

                if (isTermLoanProduct(signupState)) {
                    serialised.application.requested_products.credit_facility.approval.duration = signupState.duration;
                }

                return serialised;
            }

            generateUUID() {
                var datetime = new Date().getTime();
                var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
                    var random = (datetime + Math.random() * 16) % 16 | 0;
                    datetime = Math.floor(datetime / 16);
                    return (char === 'x' ? random : (random & 0x3 | 0x8)).toString(16);
                });
                return uid;
            }

            isValidEmail(email) {
                var emailHttpOptions = angular.copy(httpOptions);
                emailHttpOptions.params = { email: email };
                emailHttpOptions.cache = true;

                return $http.get(API_EMAIL_CHECKER_URL, emailHttpOptions)
                    .then(function (response) {
                        return { data: response.data.data.available };
                    });
            }

            postData(data) {
                return $http.post(LENDING_API_STATE_URL, data, httpOptions);
            }
        }

        function serializeLoanRequest(signupState) {
            switch (signupState.urgency) {
                case 1:
                    return {
                        urgency: 'future_use',
                        amount: signupState.requestedAmount
                    };
                case 2:
                    return {
                        urgency: 'weeks',
                        amount: signupState.requestedAmount,
                        purpose: signupState.reason,
                        detailed_purpose: (signupState.reason === 'other' ? signupState.detailedReason : undefined),
                    };
                case 3:
                    return {
                        urgency: 'asap',
                        amount: signupState.requestedAmount,
                        purpose: signupState.reason,
                        detailed_purpose: (signupState.reason === 'other' ? signupState.detailedReason : undefined),
                    };
                default:
                    return {};
            }
        }

        function isTermLoanProduct(signupState) {
            return angular.isNumber(signupState.duration);
        }

        return SignupLendingAPIHelper;
    });